declare global {
  interface Window {
    Cookiebot: any;
    OneTrust: any;
    OnetrustActiveGroups: string;
  }
}

export interface ExtendedDataLayerServiceWindow {
  dataLayerService: DataLayerService;
  mindShiftNav: any;
  lidldata: Collections[];
  navBreadcrumbDetails: any;
  dataLayer: any[];
  dataLayerNext: any[];
  google_tag_manager: Record<string, any>;
  GoogleAnalyticsObject: any;
  CookieConsent: Record<string, any>;
  dlsLoadedAndPVChecked: boolean;
}

export type Nullable<T> = T | null;

export type Undefinable<T> = T | undefined;

export interface ApplicationCollection {
  applicationID?: string;
  moduleID?: string;
  region?: string;
  managementUnit?: string;
  country?: string;
  language?: string;
  locale?: string;
  currency?: string;
  applicationVersion?: string;
  applicationEnvironment?: string;
  client_id?: string;
  country_code?: string;
  redirect_url?: string;
}

export interface ClickCollection {
  linkName?: string | HTMLElement;
  linkType?: string | HTMLElement;
  linkURL?: string | HTMLElement;
}

export interface ContentCollection {
  contentID?: string | HTMLElement;
  contentLabel?: string;
  contentType?: string | HTMLElement;
  personalisationAbTest?: boolean;
  personalisationAbTestGroup?: string;
  contentComponentSource?: string;
}

export interface EcommerceCollection {
  basketValueNet?: number;
  basketValueGross?: number;
  basketValueTax?: number;
  voucherName?: string; // deprecated
  voucherCode?: string;
  voucherValue?: string; // deprecated
  shippingCost?: number;
  paymentMethod?: string;
  adressType?: string;
  additionalServices?: any[];
  transactionID?: string;
  purchase?: string;
  cartId?: string;
  additionalShippingCost?: number | string;
  additionalShippingCostType?: string;
  basketValueAOV?: number,
  cancellationReason?: string;
  paymentFees?: number;
}

export interface EventInfoCollection {
  eventAction?: string;
  eventCategory?: string;
  eventInteractionType?: string;
  errorMessage?: string;
}

export interface FileCollection {
  fileName?: string | HTMLElement;
  fileURL?: string | HTMLElement;
}

export interface FilterSortOrder {
  sortby?: string;
  order?: string;
}

export enum FilterType {
  'single_value' = 'single_value',
  'multi_value' = 'multi_value',
  'range' = 'range',
  'complex' = 'complex',
}

export interface FilterListFilter {
  sortOrder?: FilterSortOrder[];
  numberOfResults?: number;
  type?: FilterType;
  name?: string;
  values?: string[];
  lowerbound?: string;
  upperbound?: string;
}

export interface FilterCollection {
  filterlist?: FilterListFilter[];
  filtersUsed?: string;
}

export interface PageProperties {
  maxCount?: number;
  viewportPages?: number;
}

export interface PageCollection {
  pageURL?: string;
  pageParameter?: string;
  pageTitle?: string;
  pageCmsID?: string;
  pageCmsTitle?: string;
  pageProperties?: PageProperties;
}

export interface ProcessCollection {
  stepName?: string;
  stepNumber?: string;
}

export interface ListProduct {
  brand?: string;
  type?: string;
  id?: string | number;
  parentId?: string;
  name?: string;
  categoryPrimary?: string;
  categoryPrimaryPath?: string;
  categoryPrimaryId?: string;
  categorySecondary?: string;
  categoryTree?: Record<string, any>;
  campaignTree?: Record<string, any>;
  price?: number;
  voucherCode?: string;
  currency?: string;
  netPrice?: number;
  grossPrice?: number;
  quantity?: number;
  availability?: string;
  aov?: number;
  ranking?: number;
  tradeType?: string;
  variantAttributes?: string;
  forwardingSurcharge?: number;
  environmentTax?: string;
  productDeliveryTime?: string;
  position?: number;
  status?: string;
  statusRecommandation?: string;
  ratingAverage?: number;
  ad?: string;
  adId?: string;
  sapId?: string;
  additionalShippingCost?: number | string,
  additionalShippingCostType?: string;
  shippingCostHomeDeliveryCharge?: number,
  shippingCostHomeDeliveryXlCharge?: number,
  shippingCostParcelLockerDeliveryCharge?: number,
  shippingCostParcelShopDeliveryCharge?: number,
  listId?: string;
  listName?: string;
  variantId?: string;
  variantGroupId?: string;
  returnReason?: string;
  returnQuantity?: number;
  returnUnpacked?: string;
  valueTax?: number;
}

export interface ProductsCollection {
  list?: ListProduct[];
}

export interface ListPromotion {
  creativeName?: string;
  creativeSlot?: string;
  sectionID?: string;
  sectionName?: string;
  linkURL?: string;
  type?: string;
  locationId?: string;
  promotionId?: string;
  promotionName?: string;
  ad?:string;
  products?: ListProduct[]
}

export interface PromotionsCollection {
  list?: ListPromotion[];
}

export interface KameleoonCollection {
  campaignName?: string;
  campaignId?: string;
  variationName?: string;
  variationId?: string;
}

export interface PromotionItemCollection {
  creativeName?: string;
  creativeSlot?: string;
  sectionID?: string;
  sectionName?: string;
  linkURL?: string;
  type?: string;
  locationId?: string;
  promotionId?: string;
  promotionName?: string;
  ad?:string;
  products?: ListProduct[]
}

export interface PromotionItem {
  id?: number,
  name?: string,
  brand?: string,
  categoryPrimary?: string,
  price?: number,
}

export interface SearchCollection {
  searchTerm?: string;
  searchTermSuggested?: string;
  searchTermSuggestedCategory?: string;
  searchTermMasterQuery?: string,
  searchTermSuggestedLastSearched?: string;
  searchAdvisorCampaignName?: string;
  searchAdvisorCampaignClick?: string;
  searchTermBrand?: string;
  searchURL?: string;
}

export interface SocialCollection {
  networkName?: string | HTMLElement;
  socialInteractionType?: string | HTMLElement;
}

export interface UserCollection {
  userID?: string;
  userGender?: string;
  userAge?: number;
  userType?: string;
  userPostalCode?: string;
  userNewsletterStatus?: boolean;
  userCity?: string;
  userBirthYear?: number;
  browserResolutionHeight?: number;
  browserResolutionWidth?: number;
  browserResolutionBreakpoint?: number;
  browserResolutionOrientation?: string;
  trafficType?: string;
  trafficWebView?: string;
  salesChannel?: string;
  loginMethod?: string;
  loginSaltValue?: string;
  customerMail?: string;
  customerShop?: string;
  adSessionId?: string;
  userAgent?: string;
  lidl_id?: string;
}

export interface AuthCollection {
  hashValue?: string;
  type?: string;
  reason?: string;
  lidl_id?: string;
}

export interface AuthCollection {
  hashValue?: string;
  type?: string;
  reason?: string;
}

export interface Collections {
  eventInfo?: EventInfoCollection;
  application?: ApplicationCollection;
  user?: UserCollection;
  page?: PageCollection;
  content?: ContentCollection;
  click?: ClickCollection;
  file?: FileCollection;
  products?: ProductsCollection;
  promotions?: PromotionsCollection;
  promotionItem?: PromotionItemCollection;
  social?: SocialCollection;
  ecommerce?: EcommerceCollection;
  process?: ProcessCollection;
  search?: SearchCollection;
  filter?: FilterCollection;
  kameleoon?: KameleoonCollection;
  auth?: AuthCollection;
}

export enum ScenarioStatus {
  NOT_SUPPORTED = 'Scenario not supported',
}

export enum ScenarioName {
  'PDP_Pageload' = 'PDP_Pageload',
  'PDP_Click' = 'PDP_Click',
  'PLP_Product_Click' = 'PLP_Product_Click',
  'PDP_Social_Click' = 'PDP_Social_Click',
  'PDP_Image_Click' = 'PDP_Image_Click',
  'PDP_Section_EnterViewport' = 'PDP_Section_EnterViewport',
  'PDP_Recommendation_Load' = 'PDP_Recommendation_Load',
  'PDP_Recommendation_EnterViewport' = 'PDP_Recommendation_EnterViewport',
  'PDP_Recommendation_Click' = 'PDP_Recommendation_Click',
  'PDP_Rating_Click' = 'PDP_Rating_Click',
  'PDP_Information_Load' = 'PDP_Information_Load',
  'PDP_A_Goods_Link_Click' = 'PDP_A_Goods_Link_Click',
  'PDP_Downloads_Link_Click' = 'PDP_Downloads_Link_Click',
  'PDP_Downloads_Section_Click' = 'PDP_Downloads_Section_Click',
  'General_Pageload' = 'General_Pageload',
  'General_Recommendation_Load' = 'General_Recommendation_Load',
  'General_RecommendationProduct_EnterViewport' = 'General_RecommendationProduct_EnterViewport',
  'General_Product_Click' = 'General_Product_Click',
  'General_Section_EnterViewport' = 'General_Section_EnterViewport',
  'General_Teaser_Click' = 'General_Teaser_Click',
  'General_Link_Click' = 'General_Link_Click',
  'PLP_Pageload' = 'PLP_Pageload',
  'PLP_FilterSelect_Click' = 'PLP_FilterSelect_Click',
  'General_SearchTermConfirm_Click' = 'General_SearchTermConfirm_Click',
  'Cart_Pageload' = 'Cart_Pageload',
  'Cart_Pageload_Split' = 'Cart_Pageload_Split',
  'Cart_Button_Click' = 'Cart_Button_Click',
  'Cart_Success_Pageload' = 'Cart_Success_Pageload',
  'Banner_Promotion_Load' = 'Banner_Promotion_Load',
  'General_Product_View' = 'General_Product_View',
  'General_Promotion_View' = 'General_Promotion_View',
  'General_Promotion_View_Split' = 'General_Promotion_View_Split',
  'General_Promotion_Load' = 'General_Promotion_Load',
  'General_Promotion_Click' = 'General_Promotion_Click',
  'General_Navigation_Click' = 'General_Navigation_Click',
  'Wishlist_Pageload' = 'Wishlist_Pageload',
  'Wishlist_Button_Click' = 'Wishlist_Button_Click',
  'StoreSearch_Pageload' = 'StoreSearch_Pageload',
  'StoreSearch_Click' = 'StoreSearch_Click',
  'StoreSearchDP_Pageload' = 'StoreSearchDP_Pageload',
  'StoreSearchDP_Click' = 'StoreSearchDP_Click',
  'MyAccount_Pageload' = 'MyAccount_Pageload',
  'MyAccount_Click' = 'MyAccount_Click',
  'Flyer_Click' = 'Flyer_Click',
  'Flyer_View' = 'Flyer_View',
  'Flyer_ChangeViewport' = 'Flyer_ChangeViewport',
  'Flyer_Categories_Select' = 'Flyer_Categories_Select',
  'Kameleoon_Experiment' = "Kameleoon_Experiment",
  "Order_Cancellation_Click" = "Order_Cancellation_Click",
  "Order_ViewDetails_Click" = "Order_ViewDetails_Click",
  "Order_Invoice_Download_Click" = "Order_Invoice_Download_Click",
  "Order_Return_Click" = "Order_Return_Click",
  "Order_Cancellation_Confirmation" = "Order_Cancellation_Confirmation",
  "Order_Return_Confirmation" = "Order_Return_Confirmation",
  'Start_Login_Click' = 'Start_Login_Click',
  'Login_Button_Click' = 'Login_Button_Click',
  'Login_Success' = 'Login_Success',
  'Failed_Login' = 'Failed_Login',
  'Login_Link_Click' = 'Login_Link_Click',
  'Forgotten_Password_Click' = 'Forgotten_Password_Click',
  'Password_Reset' = 'Password_Reset',
  'Register_Link_Click' = 'Register_Link_Click',
  'Finish_Registration_Click' = 'Finish_Registration_Click',
  'Registration_Success' = 'Registration_Success',
  'Send_Confirmation_Email' = 'Send_Confirmation_Email',
  'Failed_Registration' = 'Failed_Registration',
  'Error_Message' = "Error_Message",
  'Newsletter_Form_Submit' = 'Newsletter_Form_Submit',
  'Newsletter_Form_Success' = 'Newsletter_Form_Success',
}

export interface DataLayerService {
  push: (event: DataLayerServiceEvent) => Undefinable<Collections[]>,
  initialized: boolean
}

export interface DataLayerServiceEvent {
  scenarioName: ScenarioName,
  collections: Collections
}

export interface MobileCheckoutParameters {
  gaClientID?: string;
  gaDataSource?: string;
  cartId?: string;
  salesChannel?: string;
  track?: string; // TODO: check if this is correct
}


declare global {
  interface Window extends ExtendedDataLayerServiceWindow {
    AnalyticsWebInterface: any;
    webkit: any;
  }
}
